/*
 * @Author: cc
 * @Date: 2019-12-19 18:16:14
 * @LastEditTime: 2021-09-30 17:23:21
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\preview\websitPreview.js
 * @Description: 网站渠道查看页
 */
'use strict';

angular.module('websitePreviewModule', []).controller('websitePreviewCtrl', [
    '$scope',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$window',
    'trsHttpService',
    '$stateParams',
    'editcenterRightsService',
    'modalDialog',
    'websiteService',
    'trsPrintService',
    'localStorageService',
    'newMediaService',
    'editingCenterService',
    'editingMediatype',
    function (
        $scope,
        $element,
        $compile,
        $q,
        $state,
        $window,
        trsHttpService,
        $stateParams,
        editcenterRightsService,
        modalDialog,
        websiteService,
        trsPrintService,
        localStorageService,
        newMediaService,
        editingCenterService,
        editingMediatype
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.data = {
                params: {
                    serviceid: 'mlf_website',
                    methodname: 'getPicsDoc',
                    MetaDataId: $stateParams.wzmetadataid,
                    MetaDataIds: $stateParams.wzmetadataid,
                    ChnlDocIds: $stateParams.wzchnldocid,
                    ChannelId: $stateParams.wzchannelid,
                    fromsearch: $stateParams.fromsearch
                },
                typeOfAttachmentArr: [],
                editPath: websiteService.getEditandPreviewPath().edit,
                item: [],
                METADATAID: $stateParams.wzmetadataid,
                mediaArray: [],
                authorInfo: true,
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                },
            };
            $scope.list = {};
            if (!!$stateParams.iwometadataid) {
                $scope.data.params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getWebFusionDoc',
                    sourceDocId: $stateParams.iwometadataid,
                };
            }
            $scope.videos = [];
            $scope.status = {
                picsModelShow: true,
                // 是否只是展示（比如稿件收藏），不需要请求权限、上一篇、下一篇等功能
                onlyPreview: $state.params.wzchannelid === '0',
                // 显示操作栏
                // contentControllShow: typeof $state.params.wzplatform !== 'undefined',
                btnRights: {},
                // 顶部按钮权限
                btnRightsName: ['web.daibian', 'web.daishen', 'web.yiqianfa', 'web.signtime', 'web.recyclemgr', 'web.draft'],
                // 网站待编，待审
                directSigned: ['webDaiBianPublish', 'webDaiShenPublish'],
                // 直接签发，定时签发
                timeingSinged: ['webDaiBianTimingPublish', 'webDaiShenTimingPublish'],
                // 判断从哪块进入
                platform: {
                    daibian: 0,
                    daishen: 1,
                    yiqianfa: 2,
                    signtime: 3,
                    recyclemgr: 4,
                    draft: 5,
                },
                previewBigFace: {
                    status: false,
                }, // 查看痕迹
                preview: {
                    news: 1,
                    atlas: 2,
                    subject: 3,
                    linkDoc: 4,
                    video: 7,
                },
                listOpen: 1,
                // 初始化按钮
                initBth: true,
                // 通过typeId 来判断进入新闻还是图集
                methodname: {
                    1: 'getNewsDoc',
                    2: 'getPicsDoc',
                    3: 'getSpecialDoc',
                    4: 'getLinkDoc',
                    7: 'getVideoDoc',
                },
                // 是否含有各种类型的媒体
                media: {
                    noPic: '0',
                },
                typeOfDraft: $stateParams.wztypeid,
                chnldocids: [],
                metadataids: [],
                typeids: [],
                channelid: '',
                siteid: '',
                authorInfo: true,
                fusionWeb: !!$stateParams.iwometadataid, // 融合稿件预览
                isCollectDraft: $stateParams.iwomodalname === 'iwo.collect',
                isawaitrevise: $state.params.isawaitrevise, // 是否是待修订稿件
            };
            getUeditorCss();
        }

        /**
         * [getDraftStage description] 获取当前稿件在哪个审核阶段（去除需要传入的wzplatform的情况，主要是从IM来的稿件）
         * @return  {[type]}  [return description]
         */
        function getDraftStage() {
            editingCenterService.getDraftStage($scope.data.item, {
                mediatype: editingMediatype.website,
                metadataid: $state.params.wzmetadataid
            }).then((data) => {
                $state.params.wzplatform = data;
                $scope.status.contentControllShow = typeof $state.params.wzplatform !== 'undefined';
                dealRights();
            });
        }

        /**
         * [dealRights description] 处理权限
         * @return  {[type]}  [return description]
         */
        function dealRights() {
            if ($scope.status.onlyPreview) {
                return;
            }
            // 误删，链接稿没有创作轴按钮，依靠此判断
            if (!$stateParams.iwometadataid) {
                $scope.data.params.methodname = $scope.status.methodname[$stateParams.wztypeid];
            }
            if (!!$stateParams.iwometadataid) {
                // web
                if (!$stateParams.departmentDocId) {
                    editcenterRightsService.initIwoListBtn($stateParams.iwomodalname).then(function (data) {
                        $scope.status.btnRights = data;
                    });
                } else {
                    getDepartDocAuthority();
                }
                // 获取查看痕迹按钮权限
                editcenterRightsService.initIwoListBtn('iwo.trace').then(function (data) {
                    $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
                });
            } else {
                // 获取查看痕迹按钮权限
                editcenterRightsService.getRightsofBigFace($stateParams.wzsiteid, 'website.trace').then(function (data) {
                    $scope.status.bigFaceRights = !!data['website.trace.chakan'] ? 'true' : 'false';
                });
            }
            if (!$stateParams.iwometadataid && typeof $state.params.wzplatform !== 'undefined') {
                if ($state.params.wzplatform > 2) {
                    editcenterRightsService
                        .initWebsiteListBtnWithoutChn($scope.status.btnRightsName[$state.params.wzplatform], $stateParams.wzsiteid)
                        .then(function (rights) {
                            $scope.status.btnRights = rights;
                        });
                } else {
                    editcenterRightsService
                        .initWebsiteListBtn($scope.status.btnRightsName[$state.params.wzplatform], $stateParams.wzchannelid)
                        .then(function (rights) {
                            $scope.status.btnRights = rights;
                        });
                }
            }
        }

        /**
         * [getDepartDocAuthority description]获得部门稿库权限
         *
         * @return  {[type]}  [return description]
         */
        function getDepartDocAuthority() {
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperkeyOfDeptmentalDoc',
                DepartmentalDocId: $stateParams.departmentDocId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    $scope.status.btnRights[data[i]] = true;
                }
            });
        }

        /**
         * [getUeditorCss description] 加载编辑器中的相关样式
         * @return {[type]} [description]
         */
        function getUeditorCss() {
            $('.lazyload').remove();
            LazyLoad.css('./lib/ueditor2/themes/iframe.css');
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData($scope.data.params).then(function () {
                loadDirective();
                getDraftStage();
                loadVersionTimePanel();
            });
        }

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var htmlContent = '<div adjustsize class="padding20" trs-play-audio-video  ng-bind-html="item.HTMLCONTENT|trsSceHtmlContent">';
            var videoContent = '<div trs-upload-for-xj-video-draft list="item" preview="true"></div>';
            newMediaService.previewLoadDirective($element, $compile, $scope, htmlContent, videoContent);
        }

        /**
         * [requestData description]数据请求
         * @param  {[obj]} params [description]请求参数
         * @return {[obj]}        [description]请求返回值
         */
        function requestData(params) {
            var deferred = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.item = data;
                $scope.item = data;
                $scope.item.keywords = [];
                editingCenterService.queryVerifyDoc($scope.data.item);
                if (angular.isDefined($scope.item.ABSTRACT)) {
                    $scope.item.ABSTRACT = $scope.item.ABSTRACT.replace(/\n/g, '<br/>');
                }
                if ($scope.item.KEYWORDS) {
                    $scope.item.keywords = $scope.item.KEYWORDS.split(';');
                }

                $scope.extendItems = data.RELATEDNEWS;
                getAttachFileType(data.ATTACHFILE);
                document.title = data.TITLE;
                if (!$state.params.iwometadataid) {
                    editingCenterService.queryVerifyDoc($scope.data.item);
                }
                if (!!$stateParams.iwometadataid && !!$scope.list) {
                    $scope.item.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
                    $scope.item.FGD_AUTHINFO = $scope.list.FGD_AUTHINFO;
                    $scope.item.FGD_EDITINFO = $scope.list.FGD_EDITINFO;
                    $scope.item.DOCSOURCENAME = $scope.list.DOCSOURCENAME; // web
                }
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function (direction) {
            var pageTurningData;
            var metadataid;
            if (!!$stateParams.iwometadataid) {
                pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
                metadataid = $stateParams.iwometadataid;
            } else {
                pageTurningData = JSON.parse(localStorageService.get('websitePreview'));
                metadataid = $stateParams.wzmetadataid;
            }
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (
                    pageTurningData[i].METADATAID === metadataid ||
                    pageTurningData[i].MLFID === metadataid ||
                    pageTurningData[i].DOCID === metadataid
                ) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if (!!$stateParams.iwometadataid) {
                if ($stateParams.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($stateParams.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPE, toPageData.DOCID, toPageData.CHNLDOCID);
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID, '', '', toPageData.DEPARTDOCRELID);
                }
            } else {
                $state.go($state.current.name, {
                    wzchnldocid: toPageData.CHNLDOCID,
                    wzchannelid: toPageData.CHANNELID,
                    wzmetadataid: toPageData.METADATAID,
                    wztypeid: toPageData.DOCTYPEID,
                    wzsiteid: $stateParams.wzsiteid,
                    wzplatform: $state.params.wzplatform,
                }, {
                    reload: true
                });
            }
        };

        /**
         * [fusionGostate description] 融合采编预览页跳转
         * @param   {[type]}  doctype         [doctype description]
         * @param   {[type]}  iwometadataid   [iwometadataid description]
         * @param   {[type]}  iwochnldocid    [iwochnldocid description]
         * @param   {[type]}  mlftype         [mlftype description]
         * @param   {[type]}  collectid       [collectid description]
         * @param   {[type]}  departdocrelid  [departdocrelid description]
         * @return  {[type]}                  [return description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid, departdocrelid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var routerParams = {
                iwotype: doctype,
                iwomodalname: $stateParams.iwomodalname,
                wzplatform: 0,
                wztypeid: doctype,
                appplatform: 0,
                newspapertype: 2,
                iwometadataid: iwometadataid,
                iwochnldocid: iwochnldocid,
                mlftype: mlftype, // 是否来自资源中心
                iwodoccollectrelid: collectid,
                departdocrelid: departdocrelid,
            };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) {
                getBindingMediaIds(iwometadataid).then(function (bingdingData) {
                    angular.forEach(bingdingData, function (value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        }
                    });
                    $state.go($state.current.name, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go($state.current.name, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [getAttachFileType description]获取附件后缀
         * @param  {[obj]} data   [description]请求参数
         * @return {[obj]}        [description]请求返回值
         */
        function getAttachFileType(data) {
            var video = ['avi', 'wma', 'rmvb', 'rm', 'flash', 'mp4', 'mid', '3GP'];
            var audio = ['mp3'];
            var pic = ['jpg', 'jpeg', 'gif', 'png', 'bmp'];
            angular.forEach(data, function (value, key) {
                var index = value.SRCFILE.lastIndexOf('.');
                var attach = value.SRCFILE.slice(index + 1);
                if (video.indexOf(attach) > -1) {
                    value.TYPE = 'video';
                } else if (audio.indexOf(attach) > -1) {
                    value.TYPE = 'audio';
                } else if (pic.indexOf(attach) > -1) {
                    value.TYPE = 'img';
                } else {
                    value.TYPE = 'txt';
                }
            });
        }

        // 创作轴
        $scope.creationAxis = function () {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'addPersonalMaterialOfTxt',
                PersonalMaterialId: 0,
                metadataid: $stateParams.wzmetadataid,
                MediaType: '2',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };

        /**
         * [preview description]稿件预览
         * @return {[type]} [description]null
         */
        $scope.preview = function () {
            var params = {
                methodname: 'preview',
                serviceid: 'mlf_metadatacenter',
                ObjectId: $stateParams.wzchnldocid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $window.open(data.URLS);
            });
        };

        /**
         * [printBtn description] 打印
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function () {
            requestPrintVersion($stateParams.wzmetadataid).then(function (data) {
                requestPrintData(data);
            });
        };

        /**
         * [requestPrintVersion description] 打印请求流程
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function requestPrintVersion(item) {
            var deferred = $q.defer();
            trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), { serviceid: 'mlf_metadatalog', methodname: 'query', MetaDataId: item }, 'get')
                .then(function (data) {
                    deferred.resolve(data.DATA);
                });
            return deferred.promise;
        }

        /**
         * [requestPrintData description] 打印请求详情
         * @param   {[type]}  version  [version description]
         * @return  {[type]}           [return description]
         */
        function requestPrintData(version) {
            var params = {
                serviceid: 'mlf_website',
                methodname: $scope.status.methodname[$stateParams.wztypeid],
                MetaDataId: $stateParams.wzmetadataid,
            };
            $scope.data.printResult = [];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                trsPrintService.trsWebPrintDocument($scope.data.printResult);
            });
        }

        /**
         * [bigFace description] 查看痕迹
         * @return {[type]} [description]
         */
        $scope.bigFace = function () {
            if ($scope.data.item.DOCTYPEID === '2' || $scope.data.item.DOCTYPEID === '7') {
                $scope.status.picsModelShow = !$scope.status.picsModelShow;
            }
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        };

        /**
         * [textareaFormat description] 将文字内容中的空格和换行符转化
         * @param  {[type]} content [description] 文字内容
         * @return {[type]}         [description]
         */
        $scope.textareaFormat = function (content) {
            return content.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
        };

        /**
         * [goToEdit description]
         * @return  {[type]}  [return description]
         */
        $scope.goToEdit = function () {
            var urlParams = {
                wzplatform: $state.params.wzplatform,
                siteid: $state.params.wzsiteid,
                mediaType: '2'
            };
            editingCenterService.routerToEditorWithLock(angular.extend($scope.item, urlParams));
        };

        /**
         * [loadVersionTimePanel 动态加载流程版本信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadVersionTimePanel() {
            var versionPanel =
                '<version-time-panel incoming-data="data.item"></version-time-panel>';
            versionPanel = $compile(versionPanel)($scope);
            $element.find('versionPanel').append(versionPanel);
        }
    },
]);
